import PropTypes from 'prop-types';

import { Paragraph } from '@vimeo/iris/typography';

const GuideTable = function (props) {
  const { tableNumber, description, headers, rows } = props;

  let anchor;
  if (description) {
    anchor = 'table-' + tableNumber;
  }

  // Because React requires common elements to have unique keys on them, this function will
  // dynamically handle that.
  function keyify(element) {
    if (!Array.isArray(element)) {
      return element;
    }

    return element.map(function (e, i) {
      if (typeof e === 'string') {
        return e;
      }

      return <span key={`keyed-elem-${i}`}>{e}</span>;
    });
  }

  return (
    <div>
      {description && (
        <Paragraph
          size="3"
          id={anchor}
          key={`guide-table-${anchor}`}
          style={{ textAlign: 'center' }}
        >
          <em>
            Table {tableNumber}. {keyify(description)}
          </em>
        </Paragraph>
      )}

      <table style={{ marginTop: '0', marginBottom: '1rem' }}>
        <thead>
          <tr>
            {Object.keys(headers).map(function (i) {
              return <th key={`guide-headers-${i}`}>{keyify(headers[i])}</th>;
            })}
          </tr>
        </thead>
        <tbody>
          {Object.keys(rows).map(function (i) {
            return (
              <tr key={`guide-row-${i}`}>
                {Object.keys(rows[i]).map(function (ii) {
                  return <td key={`guide-row-${i}-col-${ii}`}>{keyify(rows[i][ii])}</td>;
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

GuideTable.propTypes = {
  description: PropTypes.any,
  headers: PropTypes.arrayOf(PropTypes.any).isRequired,
  rows: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.any), PropTypes.bool]))
    .isRequired,
  tableNumber: PropTypes.number,
};

export default GuideTable;
